import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2eea9a0c")

_pushScopeId("data-v-2eea9a0c")
const _hoisted_1 = { class: "flex flex-col p-3" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "label" }, "COMPETENCY", -1)
const _hoisted_5 = { class: "flex items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["body-wrapper", { 'body-wrapper-active': _ctx.active }]
  }, [
    _createVNode("div", {
      class: ["active-tab-marker", { 'active-tab-marker-active': _ctx.active }]
    }, null, 2),
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.progressArray, (item, index) => {
            return (_openBlock(), _createBlock("span", {
              key: index,
              class: ["item-dot", { 'item-dot-complete': item.complete }]
            }, null, 2))
          }), 128))
        ])
      ])
    ])
  ], 2))
})